import React from 'react'
import Link from 'gatsby-link'

const liStyle = {
    // display: 'inline',
    marginBottom: '1em',
}

const rotateLiStyle = {
    display: 'inline',
    marginBottom: '1em',
}

const linkStyle = {
    color: 'red',
    fontFamily: 'Courier, monospaced',
    border: '1px solid red',
    padding: '3px',
    marginRight: '2rem',
    cursor: 'pointer',
};

const TopLinks = ({rotateScreen, resetScreen, degrees}) => (
  <div 
    className="main-menu" 
    style={{
        margin: '0 auto',
        maxWidth: 960,
        // padding: '1.45rem 1.0875rem',
        float: 'left',
      }}>
        <ul style={{listStyleType: 'none', textAlign: 'left'}}>
            <li style={liStyle}>
                <Link to="/bio" style={linkStyle}>
                    bio
                </Link>
            </li>
            <li style={liStyle}>
                <Link to="" style={linkStyle}>
                    ????
                </Link>
            </li>
            <li style={rotateLiStyle}>
                <span style={linkStyle} onClick={rotateScreen}>
                    rotate 6° clockwise
                </span>
            </li>
            <li style={rotateLiStyle}>
                <span style={{
                    color: '#5f9cd2',
                    fontFamily: 'Courier, monospaced',
                    border: '1px solid #5f9cd2',
                    padding: '3px',
                    marginLeft: '-1rem',
                    cursor: 'pointer',
                    display: degrees == 0 ? 'none' : 'initial',
                }}
                onClick={resetScreen}>
                    ↺
                </span>
            </li>
        </ul>
  </div>
)

export default TopLinks


// WEBPACK FOOTER //
// ./src/components/topLinks.js